import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Time Report Details",
    name: "time-reports.details",
    path: "/app/time-reports/:timeReportGuid",
  },
  {
    acl: [],
    label: "Time Report Calendar",
    name: "time-reports.details.calendar",
    path: `/app/time-reports/:timeReportGuid/?tab=calendar`,
  },
  {
    acl: [],
    label: "Time Report Specification",
    name: "time-reports.details.specification",
    path: `/app/time-reports/:timeReportGuid/?tab=specification`,
  },
  {
    acl: [],
    label: "Time Report Versions",
    name: "time-reports.details.versions",
    path: `/app/time-reports/:timeReportGuid/?tab=versions`,
  },
  {
    acl: [],
    label: "Time Report Lifecycle",
    name: "time-reports.details.lifecycle",
    path: `/app/time-reports/:timeReportGuid/?tab=lifecycle`,
  },
  {
    acl: [],
    label: "Time Report Summary",
    name: "time-reports.details.summary",
    path: `/app/time-reports/:timeReportGuid/?tab=summary`,
  },
  {
    acl: [],
    label: "Time Report Related",
    name: "time-reports.details.related",
    path: `/app/time-reports/:timeReportGuid/?tab=related`,
  },
  {
    acl: [],
    label: "Time Reports",
    name: "time-reports",
    path: "/app/time-reports",
  },
];

export const router = routerFrom(routes);
